import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";

const AgregarEntrega = () => {
  // Estados para los campos del formulario
  const [nombrePaciente, setNombrePaciente] = useState("");
  const [documentoPaciente, setDocumentoPaciente] = useState("");
  const [nombreDoctorConsultorio, setNombreDoctorConsultorio] = useState("");
  const [direccion, setDireccion] = useState("");
  const [tipoEntrega, setTipoEntrega] = useState("");
  const [error, setError] = useState(null);

  // Nuevos estados para la lógica de dirección y datos de usuario/tiempo
  const [deliveryOption, setDeliveryOption] = useState("Direccion de doctor"); // Estado para seleccionar tipo de dirección
  const [deliveryTime, setDeliveryTime] = useState(""); // Estado para la hora de la entrega
  const [userName, setUserName] = useState(""); // Estado para el nombre del usuario

  const history = useHistory();

  // useEffect para obtener el nombre de usuario al cargar el componente
  useEffect(() => {
    const sesionActiva = localStorage.getItem("sesionActiva");
    if (sesionActiva) {
      const storedUserName = localStorage.getItem("nombre");
      if (storedUserName) {
        setUserName(storedUserName);
      }
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Capturar la hora actual al momento de enviar el formulario
    const now = new Date();
    const formatDateTime = (date) => {
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, "0");
      const day = `${date.getDate()}`.padStart(2, "0");

      let hours = date.getHours();
      const minutes = `${date.getMinutes()}`.padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";

      hours = hours % 12;
      hours = hours ? hours : 12; // 0 => 12

      return `${year}-${month}-${day} - ${hours}:${minutes} ${ampm}`;
    };

    const formattedTime = formatDateTime(now);
    setDeliveryTime(formattedTime);

    // Determinar la dirección final a enviar
    let finalDireccion = direccion;
    if (deliveryOption === "RX ORAL") {
      finalDireccion = "RX ORAL"; // Si es RX ORAL, la dirección es "RX ORAL"
    }

    try {
      const response = await axios.post(
        // "http://localhost/mensajeriaRX/mensajeriaRX/mensajeria/src/baseDatos/agregarEntrega.php",
        `./agregarEntrega.php`,
        {
          nombrePaciente,
          documentoPaciente,
          nombreDoctorConsultorio,
          direccion: finalDireccion, // Usar la dirección final determinada
          tipoEntrega,
          deliveryTime: formattedTime, // Enviar la hora de la entrega
          userName, // Enviar el nombre del usuario
        }
      );
      const data = response.data;
      if (data.success) {
        Swal.fire({
          icon: "success",
          title: "Entrega agregada",
          text: `La entrega del Paciente ${nombrePaciente} ha sido agregada correctamente.`,
          confirmButtonText: "Aceptar",
        }).then(() => {
          history.push("/mensajeria");
        });
      } else {
        setError(data.message || "Error al agregar la entrega");
      }
    } catch (error) {
      setError("Error al conectar con el servidor: " + error.message);
    }
  };

  const handleCancel = () => {
    Swal.fire({
      title: "¿Está seguro de cancelar?",
      text: "Todos los cambios no guardados se perderán.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cancelar",
      cancelButtonText: "No, regresar",
    }).then((result) => {
      if (result.isConfirmed) {
        history.push("/mensajeria");
      }
    });
  };

  return (
    <div className="container mt-5">
      <div className="card bg-body rounded shadow-sm">
        <div className="card-header bg-dark text-white text-center">
          <h3 className="fw-bold h4">Nueva Entrega</h3>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-4">
                <label
                  htmlFor="nombrePaciente"
                  className="form-label fw-bold text-uppercase"
                >
                  Nombre del Paciente
                </label>
                <input
                  type="text"
                  id="nombrePaciente"
                  value={nombrePaciente}
                  onChange={(e) => setNombrePaciente(e.target.value)}
                  className="form-control shadow-sm"
                  placeholder="Nombre del Paciente"
                  required
                />
              </div>
              <div className="col-md-4">
                <label
                  htmlFor="documentoPaciente"
                  className="form-label fw-bold text-uppercase"
                >
                  Documento del Paciente
                </label>
                <input
                  type="text"
                  id="documentoPaciente"
                  value={documentoPaciente}
                  onChange={(e) => setDocumentoPaciente(e.target.value)}
                  className="form-control shadow-sm"
                  placeholder="Documento del Paciente"
                  required
                />
              </div>
              <div className="col-md-4">
                <label
                  htmlFor="nombre"
                  className="form-label fw-bold text-uppercase "
                >
                  Nombre del Doctor
                </label>
                <input
                  type="text"
                  id="nombreDoctorConsultorio"
                  value={nombreDoctorConsultorio}
                  onChange={(e) => setNombreDoctorConsultorio(e.target.value)}
                  className="form-control shadow-sm"
                  placeholder="Doctor o Consultorio"
                  required
                />
              </div>

              {/* Selector para el tipo de dirección de entrega */}
              <div className="col-md-6">
                <label
                  htmlFor="deliveryOption"
                  className="form-label fw-bold text-uppercase"
                >
                  Seleccione Direccion de Entrega
                </label>
                <select
                  id="deliveryOption"
                  value={deliveryOption}
                  onChange={(e) => setDeliveryOption(e.target.value)}
                  className="form-select shadow-sm"
                  required
                >
                  <option value="Direccion de doctor">
                    Dirección de Doctor
                  </option>
                  <option value="RX ORAL">RX ORAL</option>
                </select>
              </div>

              {/* Campo de dirección, condicionalmente renderizado */}
              {deliveryOption === "Direccion de doctor" && (
                <div className="col-md-6">
                  <label
                    htmlFor="direccion"
                    className="form-label fw-bold text-uppercase"
                  >
                    Dirección de Entrega
                  </label>
                  <input
                    type="text"
                    id="direccion"
                    value={direccion}
                    onChange={(e) => setDireccion(e.target.value)}
                    className="form-control shadow-sm"
                    placeholder="Ingrese la dirección"
                    required={deliveryOption === "Direccion de doctor"} // Requerido solo si es dirección de doctor
                  />
                </div>
              )}

              <div className="col-md-6">
                <label
                  htmlFor="tipoEntrega"
                  className="form-label fw-bold text-uppercase"
                >
                  Tipo de Entrega
                </label>
                <input
                  type="text"
                  id="tipoEntrega"
                  value={tipoEntrega}
                  onChange={(e) => setTipoEntrega(e.target.value)}
                  className="form-control shadow-sm"
                  placeholder="Que se entrega"
                  required
                />
              </div>

              {/* Mostrar el nombre del usuario y la hora de la entrega (solo lectura) */}
              {/* <div className="col-md-6">
                <label htmlFor="userNameDisplay" className="form-label fw-bold">
                  Usuario que registra
                </label>
                <input
                  type="text"
                  id="userNameDisplay"
                  value={userName || "Cargando..."}
                  className="form-control shadow-sm"
                  readOnly // Solo lectura
                />
              </div> */}
              <div className="col-md-6 d-none">
                <label
                  htmlFor="deliveryTimeDisplay"
                  className="form-label fw-bold"
                >
                  Hora de Registro
                </label>
                <input
                  type="text"
                  id="deliveryTimeDisplay"
                  value={deliveryTime || "Se registrará al guardar"}
                  className="form-control shadow-sm"
                  readOnly // Solo lectura
                />
              </div>
            </div>

            <div className="text-center mt-3">
              <button type="submit" className="btn btn-primary me-2">
                Agregar Entrega
              </button>
              <button
                type="button"
                onClick={handleCancel}
                className="btn btn-secondary"
              >
                Cancelar
              </button>
            </div>
            {error && (
              <div className="alert alert-danger mt-3" role="alert">
                {error}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default AgregarEntrega;
